import { createFileRoute } from '@tanstack/react-router';

import { parseTraceView, traceListFilters, traceSearch } from '../../entities/run';

// Component only in the `.lazy.tsx` sibling: the trace draws the canvas, and the events list
// must not pay for xyflow. `events_` keeps it a page of its own, not a child of the list.
export const Route = createFileRoute('/_shell/events_/runs/$runId')({
  validateSearch: (search: Record<string, unknown>): Record<string, string | number | undefined> =>
    traceSearch(parseTraceView(search), traceListFilters(search)),
});
